<script setup lang="ts">
import { VueCookieNext } from 'vue-cookie-next';
import { useRouting } from '@/composables';

const $routing = useRouting();

const onBack = () => {
  const lastRoute = VueCookieNext.getCookie('last_route');

  if (lastRoute) {
    $routing.redirectTo(lastRoute);
  }
};
</script>

<template>
  <div class="page-container">
    <div class="card flex justify-content-center flex-column card-container h-full">
      <div class="flex align-items-center justify-content-center px-6 lg:p-1">
        <img alt="404 Page Not Found" src="@/assets/images/404.svg" />
      </div>
      <div class="flex align-items-center justify-content-center p-1">
        <div class="w-10 sm:w-8 md:w-6 lg:w-4 text-sm text-center">
          <span class="font-semibold">
            Sorry, this page either doesn't exist or you don't have the required permissions to view this page.
          </span>
          <span>If you believe this is a mistake, please contact support.</span>
        </div>
      </div>
      <div class="flex align-items-center justify-content-center p-1">
        <AppButton type="secondary" text="Back" icon-left="arrow_back" @click="onBack" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-container {
  background: var(--primary-color-extra-light);

  img {
    height: auto;
    max-width: 100%;
  }
}
</style>
